export default {
  default: () => import("/opt/atlassian/pipelines/agent/build/layouts/default.vue"),
  sandbox: () => import("/opt/atlassian/pipelines/agent/build/layouts/sandbox.vue"),
  "store-flow": () => import("/opt/atlassian/pipelines/agent/build/layouts/storeFlow.vue")
}